import { FC, useEffect, useMemo } from "react";
import { Form, Tag } from "antd";
import Selector from "components/Selector/Selector";
import { t } from "i18next";
import { Attribute, FilterInfo } from "utils/models";
import { setFilterInfoData } from "redux/features/audience/queryPayloadSlice";
import { useDispatch, useSelector } from "react-redux";
import PrimaryButton from "components/Buttons/PrimaryButton/PrimaryButton";
import { FormInstance } from "antd/lib";
import AttributeCondition from "../AttributeCondition/AttributeCondition";
import { AudienceConditionTagEnum, E_OperatorEnum, EventActionEnum } from "utils/enums";
import "./EventCondition.css"
import filterIcon from "images/filterIcon.svg";
import { fetchEventList, getJourneyEvents } from "redux/features/event/eventListSlice";
import { CloseOutlined } from "@ant-design/icons";
import { getJourneyTypeList } from "helperFunctions/events";
import TraitConditionNested from "pages/Audience/Traits/components/TraitConditionNested/TraitConditionNested";
import { audienceItems } from "helperFunctions/audience";
interface EventConditionProps {
  condition: FilterInfo;
  index: number;
  form: FormInstance;
  segment?:boolean
}
// Initial value for attributes
const attributeInitialValue: Attribute = {
  operand: "",
  operator: "",
  value: [],
  type: "",
  e_operator: E_OperatorEnum.AND,
};
const EventCondition: FC<EventConditionProps> = ({ condition, index, form,segment }) => {
  const dispatch:any = useDispatch();
  const loginUser = useSelector((state: any) => state.loginUser.data);
  const { appId } = useSelector((state: any) => state.activeApp);
  const {journeyEvents:eventsByJourney,data:eventList,status:eventListStatus} = useSelector(
    (state: any) => state.eventList
  );
  const events=useMemo(()=>{
   if(segment && eventList?.length && condition.journey){
    return getJourneyEvents(eventList,condition.journey)
   }
   return []
  },[eventList,condition.journey])
  /**
   * Handles changes in the form data.
   * @param data - An object representing the  form data. Each key is a string, and values can be a string, array of strings, boolean, or undefined.
   */
  const handleInputChange = async (data: {
    [key: string]: string | string[] | boolean | undefined | Attribute[];
  }) => {
    await dispatch(
      setFilterInfoData({
        data: { ...condition, ...data },
        parentIndex: -1,
        index,
      })
    );
    // reset all other fields in block if operand or event action gets change
    if ('operand' in data  || 'action' in data) {
      form.resetFields();
    }
  };
  /**
 * Retrieves the attributes of a specific event based on the provided operand.
 *
 * @param {string | undefined} operand - The event identifier to search for.
 * @returns {Array<{ label: string; value: string; type: string }>} 
 *          - An array of event attributes containing label, value, and type.
 *          - Returns an empty array if the operand is undefined or no matching event is found.
 */
const getEventAttributes = (operand: string | undefined) => {
  const events_by_journey=segment?events:eventsByJourney
  // If operand is undefined or eventsByJourney is not available, return an empty array.
  if (!operand || !events_by_journey) return [];

  // Find the event in eventsByJourney that matches the given operand.
  const matchedEvent = events_by_journey.find(
    ({ value }: { value: string }) => value === operand
  );

  // If a matching event is found, map its list to extract event attributes.
  return (
    matchedEvent?.list.map(
      ({ name, type }: { name: string; type: string }) => ({
        label: name, 
        value: name, 
        type,      
      })
    ) || []
  );
};

  //get all attributes of selected event
  const attributes = useMemo(() => {
   return getEventAttributes(condition?.operand)
  }, [condition?.operand, eventsByJourney,events]);
  //get all attributes of selected dropoff_event
  const dropoff_attributes = useMemo(() => {
    return getEventAttributes(condition.dropoff_operand)
  }, [condition?.dropoff_operand, eventsByJourney]);
  useEffect(()=>{
    if (attributes && condition.operand && !segment) {
      
      // Transform the attributes array to the required format
      const transformedAttributes = attributes.map(
        (attr: { value: string; type: string }) => ({
          operand: attr.value,
          type: attr.type
        })
      );

      handleInputChange({ attributeList: transformedAttributes });
    }
  },[attributes,condition.operand])
useEffect(()=>{
  if(segment){
    dispatch(fetchEventList({app_id:appId,api_key:loginUser.api_key}))
  }
 return ()=>{
  form.resetFields()
 } 
},[])
  return (
    <div className="w-100 d-flex justify-content-between audience-event-step-container">
       
      <div className="d-flex flex-column gap-3">
        <div>
        {segment && (
            <div className="d-flex flex-row flex-wrap gap-md-4 gap-2">
              <div className="d-flex gap-2">
                {(condition.action == EventActionEnum.DID_PERFORM ||
                  condition?.action !== EventActionEnum.DID_NOT_PERFORM) && (
                  <PrimaryButton
                    onClick={() => {
                      handleInputChange(
                        {
                          action: EventActionEnum.DID_PERFORM ,
                          operand: undefined,
                          dropoff_operand:undefined
                          
                        }
                      );
                    }}
                  >
                    <img src={filterIcon} alt="" />
                    <span className="mx-2 w-100"> {t("didPerfromLabel")} </span>
                  </PrimaryButton>
                )}
                {(condition.action == EventActionEnum.DID_NOT_PERFORM ||
                  condition.action!== EventActionEnum.DID_PERFORM) && (
                  <PrimaryButton
                    onClick={() => {
                      handleInputChange(
                        {
                          action: EventActionEnum.DID_NOT_PERFORM ,
                          operand: undefined,
                          dropoff_operand:undefined

                        }
                      );
                    }}
                  >
                    <img src={filterIcon} alt="" />
                    <span className="mx-2 w-100">
                      {" "}
                      {t("didNotPerfromLabel")}{" "}
                    </span>
                  </PrimaryButton>
                )}
                {condition.action && (
                  <CloseOutlined
                    className="mx-2"
                    onClick={() => {
                      handleInputChange(
                        {
                          action:undefined,
                          attributes: [],
                          operator:undefined,
                          operand: undefined,
                          value: undefined,
                          interval: undefined,
                          comparison: undefined,
                          period: undefined,
                          dropoff_operand:undefined
                        },
                      );
                    }}
                  />
                )}
              </div>
              <Form.Item
                rules={[{ required: true, message: "" }]}
                name={`category_${index}`}
                className="m-0"
                initialValue={
                  condition?.tag==AudienceConditionTagEnum.LIVE_EVENT 
                    ? t("liveEventLabel") :condition?.tag==AudienceConditionTagEnum.JOURNEY_ACTION?t("journeyActionslabel"):t("pastEventLabel")
                }
                
              >
                <Selector disabled />
              </Form.Item>
             { <Form.Item
                label={t("fromJourneyLabel")}
                name={`journey_${index}`}
                initialValue={condition.journey}
                className="m-0 input-size-xlg"
              >
                <Selector
                  onChange={(value) => {
                    handleInputChange(
                      {
                        attributes: [],
                        operand: undefined,
                        journey:value
                      },
                    );
                  }}
                  placeholder={`${t("selectJourneyMsg")}`}
                  options={getJourneyTypeList(eventList)}

                ></Selector>
              </Form.Item>}
            </div>
          )}
        </div>
        <div>
          <Form.Item
            rules={[{ required: true, message: `${t("selectEventMsg")}` }]}
            className="m-0 input-size-lg"
            name={`operand_${index}`}
            initialValue={condition.operand}
          >
            <Selector
              // className="input-size-lg"
              disabled={!condition.action && segment }
              showSearch
              onChange={(value: string) => {
                handleInputChange({
                  operand:value,
                  attributes: [],
                  dropoff_attribute: undefined,
                });
              }}
              options={segment?condition?.tag===AudienceConditionTagEnum.JOURNEY_ACTION?audienceItems.journeyStepsOptions:events:eventsByJourney || []}
              placeholder={`${t("selectEventMsg")}`}
            />
          </Form.Item>
          {segment && condition.action && condition.action===EventActionEnum.DID_NOT_PERFORM && <TraitConditionNested parentIndex={-1} condition={condition} index={index} form={form}/>}
        </div>
        <div className="d-flex flex-wrap w-100 flex-column">
          {!condition.attributes || condition?.attributes?.length == 0 ? (
            <PrimaryButton
              className="input-size-sm"
              onClick={() =>
                handleInputChange({
                  attributes: [
                    { ...attributeInitialValue, e_operator: undefined },
                  ],
                })
              }
              disabled={attributes?.length == 0}
            >
              {t("attributeLabel")}
            </PrimaryButton>
          ) : (
            condition.attributes.map((_: any, attrIndex: number) => {
              return (
                <AttributeCondition
                  form={form}
                  id={index}
                  condition={condition}
                  key={`${index}_${attrIndex}`}
                  setValue={(data) => {
                    let modifiedAttribute = [...(condition?.attributes || [])];
                    if (data) {
                      modifiedAttribute[attrIndex] = data;
                    }
                    //remove the attribute object from attributes in redux
                    else {
                      modifiedAttribute.splice(attrIndex, 1);
                    }
                    handleInputChange({ attributes: modifiedAttribute });
                  }}
                  index={attrIndex}
                  attributes={attributes}
                />
              );
            })
          )}
          <div>
            {condition.attributes && condition?.attributes?.length > 0 && (
              <>
                <Tag
                  className="cursor-pointer"
                  onClick={() => {
                    handleInputChange({
                      attributes: [
                        ...(condition?.attributes || []),
                        attributeInitialValue,
                      ],
                    });
                  }}
                >
                  {t("plusWhereLabel")}
                </Tag>
              </>
            )}
          </div>
        </div>
       
      </div>
     {index && !segment?<div className="ps-2 ms-2 funnel-dropoff-container">
        <span className="">{t("inputDropoffDetailsLabel")}</span>
        <div className="d-flex gap-2 flex-wrap mt-3">
         <Form.Item
            colon={false}
            labelCol={{flex:"110px"}}
            labelAlign="left"
            label={t("dropoffEventLabel")}
            className="input-size-lg m-0"
            name={`dropoff_operand_${index}`}
            initialValue={condition.dropoff_operand || undefined}
          >
            <Selector
              showSearch
              allowClear
              onClear={()=>
                handleInputChange({
                  dropoff_operand: undefined,
                  dropoff_attribute:undefined
                })
              }
              onChange={(value: string) => {
                handleInputChange({
                  dropoff_operand: value,
                  dropoff_attribute: undefined
                });
                form.resetFields([`dropoff_attribute_${index}`])
              }}
              options={eventsByJourney || []}
            />
          </Form.Item>
            <Form.Item
              labelCol={{flex:"110px"}}
              colon={false}
              labelAlign="left"
              className="m-0 input-size-lg"
              label={t("dropoffAttributeLabel")}
              name={`dropoff_attribute_${index}`}
              initialValue={condition.dropoff_attribute || undefined}
            >
              <Selector
                showSearch
                allowClear
                onClear={()=>
                  handleInputChange({
                    dropoff_attribute: undefined,
                  })
                }
                onChange={(value: string) => {
                  handleInputChange({
                    dropoff_attribute: value,
                  });
                }}
                options={dropoff_attributes}
              />
            </Form.Item>
            </div>
            </div>:<></>}
    </div>
  );
};

export default EventCondition;


